"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _lunaIcon = _interopRequireWildcard(require("../luna-icon"));

var _depCheck = _interopRequireDefault(require("../../dep-check"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaTag = _react["default"].forwardRef(function (props, ref) {
  (0, _depCheck["default"])([]);
  var children = props.children,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      icon = props.icon,
      label = props.label,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      size = props.size,
      type = props.type,
      other = props.other;

  var getClassList = function getClassList() {
    var _classnames;

    var base = _config.classes.base,
        colors = _config.classes.colors,
        iconClass = _config.classes.iconClass,
        labelClass = _config.classes.labelClass,
        types = _config.classes.types,
        sizes = _config.classes.sizes,
        disabledClass = _config.classes.disabled;
    return (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, base, true), _defineProperty(_classnames, colors.neutral, color === _config.LunaTagColors.neutral), _defineProperty(_classnames, colors.green, color === _config.LunaTagColors.green), _defineProperty(_classnames, colors.orange, color === _config.LunaTagColors.orange), _defineProperty(_classnames, colors.red, color === _config.LunaTagColors.red), _defineProperty(_classnames, colors.blue, color === _config.LunaTagColors.blue), _defineProperty(_classnames, disabledClass, disabled), _defineProperty(_classnames, iconClass, icon), _defineProperty(_classnames, labelClass, label), _defineProperty(_classnames, types.tag30, type === _config.LunaTagTypes.tag30), _defineProperty(_classnames, types.tag10, type === _config.LunaTagTypes.tag10), _defineProperty(_classnames, sizes["default"], size === _config.LunaTagSizes["default"] || !size), _defineProperty(_classnames, sizes.small, size === _config.LunaTagSizes.small), _classnames), className);
  };

  var getClassListIcon = function getClassListIcon() {
    var childIcon = _config.classes.childIcon;
    return (0, _classnames2["default"])('luna-icon', [childIcon]);
  };

  var getIconComponent = function getIconComponent() {
    if (icon && type === _config.LunaTagTypes.tag10) {
      throw new Error("The 'icon' prop was passed alongside of type=tag10. There is no icon for type=tag10. You will need to use type=tag30 to use an icon or delete the icon prop.");
    }

    if (icon && type === _config.LunaTagTypes.tag30) {
      return _react["default"].createElement(_lunaIcon["default"], {
        className: "luna-tag--icon",
        glyph: icon
      });
    } else if (type === _config.LunaTagTypes.tag10) {
      return _react["default"].createElement("span", {
        className: getClassListIcon()
      });
    } else {
      return null;
    }
  };

  var getClassListLabel = function getClassListLabel() {
    var content = _config.classes.content;
    return (0, _classnames2["default"])([content]);
  };

  var getLabel = function getLabel() {
    if (label || type === _config.LunaTagTypes.tag10) {
      return _react["default"].createElement("span", {
        className: getClassListLabel()
      }, label);
    }
  };

  return _react["default"].createElement("span", _extends({}, other, {
    className: getClassList(),
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart,
    ref: ref
  }), getIconComponent(), getLabel(), children);
});

LunaTag.propTypes = {
  className: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(Object.values(_config.LunaTagColors)).isRequired,
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].oneOf(Object.values(_lunaIcon.LunaGlyphs)),
  label: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  size: _propTypes["default"].oneOf(Object.values(_config.LunaTagSizes)),
  type: _propTypes["default"].oneOf(Object.values(_config.LunaTagTypes)).isRequired
};
LunaTag.defaultProps = {
  size: _config.LunaTagSizes["default"],
  other: {}
};
LunaTag.displayName = 'LunaTag';
var _default = LunaTag;
exports["default"] = _default;
